<template>

    <div class="md:px-3">

        <div class="flex items-center cursor-pointer hover:bg-indigo-600 bg-indigo-500 ml-2 px-5 py-3 rounded-xl transition-colors text-white"
             v-on:click="openModal">

            <svg xmlns="http://www.w3.org/2000/svg" width="21.156" height="21.156"
                 class="h-4 md:h-6"
                 viewBox="0 0 21.156 21.156"
            >
                <g id="Group_162" data-name="Group 162">
                    <g id="Group_161" data-name="Group 161">
                        <path id="Path_35" data-name="Path 35"
                              d="M9.317,0a9.317,9.317,0,1,0,9.317,9.317A9.327,9.327,0,0,0,9.317,0Zm0,16.913a7.6,7.6,0,1,1,7.6-7.6A7.605,7.605,0,0,1,9.317,16.913Z"
                              fill="currentColor"/>
                    </g>
                </g>
                <g id="Group_164" data-name="Group 164" transform="translate(14.505 14.505)">
                    <g id="Group_163" data-name="Group 163">
                        <path id="Path_36" data-name="Path 36"
                              d="M357.444,356.228l-4.931-4.931a.86.86,0,0,0-1.216,1.216l4.931,4.931a.86.86,0,0,0,1.216-1.216Z"
                              transform="translate(-351.046 -351.046)" fill="currentColor"
                        />
                    </g>
                </g>
            </svg>

            <span class="ml-3 hidden md:inline">Zoeken</span>

        </div>

        <Transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition ease-in duration-150"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
        <div v-show="showModal"
             @click="closeModalIfNotInput($event)"
             class="fixed z-50 inset-0 overflow-y-auto bg-gray-500 bg-opacity-75"
             aria-labelledby="modal-title"
             role="dialog"
             aria-modal="true"
             style="-webkit-backdrop-filter: blur(5px); backdrop-filter: blur(5px);"
        >

            <div class="flex items-start justify-center min-h-screen p-4 text-center">

                <Transition
                    enter-active-class="transition ease-out duration-200"
                    enter-from-class="opacity-0 scale-95 -translate-y-4"
                    enter-to-class="opacity-100 scale-100 translate-y-0"
                    leave-active-class="transition ease-in duration-150"
                    leave-from-class="opacity-100 scale-100 translate-y-0"
                    leave-to-class="opacity-0 scale-95 -translate-y-4"
                >
                <div v-show="showModal"
                    class="inline-block align-bottom bg-white rounded-xl text-left overflow-hidden shadow-2xl transform sm:align-top mt-10 lg:mt-16 xl:mt-24 2xl:mt-40 sm:max-w-4xl sm:w-full">

                    <div>
                        <div class="relative rounded-md">
                            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </div>
                            <input
                                type="text"
                                ref="searchTermInput"
                                placeholder="Zoek pagina's, instellingen, of records..."
                                v-model="searchTerm"
                                class="shadow-sm ring-0 border-0 block w-full border-gray-300 py-3 pl-12 pr-6"
                                @keydown.up.prevent="selectPrevResult"
                                @keydown.down.prevent="selectNextResult"
                                @keydown.enter.prevent="goToCurrentResultIndex"
                                @keydown.esc.prevent="closeModal"
                            />
                            <div v-if="isSearching" class="absolute inset-y-0 right-0 pr-4 flex items-center">
                                <svg class="animate-spin h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                                </svg>
                            </div>
                            <div v-else-if="!searchTerm && !isSearching" class="absolute inset-y-0 right-0 pr-4 flex items-center">
                                <kbd class="hidden sm:inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-400 border border-gray-200">⌘K</kbd>
                            </div>
                        </div>
                    </div>

                    <div class="max-h-96 overflow-y-auto" ref="resultsContainer">

                        <!-- Navigation results -->
                        <template v-if="navigationResults.length > 0">
                            <div class="px-4 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider bg-gray-50 border-t border-gray-200">
                                Navigatie
                            </div>
                            <ul class="text-sm font-medium divide-y divide-gray-100">
                                <li v-for="(result, index) in navigationResults" :key="'nav-' + index">
                                    <a :href="result.url"
                                       class="flex items-center justify-between px-4 py-3 transition-all duration-75"
                                       @mouseover="selectedResultIndex = result._globalIndex"
                                       :class="[result._globalIndex === selectedResultIndex ? 'bg-indigo-500 text-white' : 'text-gray-800 hover:bg-gray-50']">

                                        <div class="flex items-center gap-3 min-w-0">
                                            <i v-if="result.icon" :class="[result.icon, result._globalIndex === selectedResultIndex ? 'text-indigo-200' : 'text-gray-400']" class="w-4 text-center text-sm"></i>
                                            <span class="truncate">{{ result.title }}</span>
                                        </div>

                                        <span class="text-xs ml-4 flex-shrink-0"
                                              :class="result._globalIndex === selectedResultIndex ? 'text-indigo-200' : 'text-gray-400'">
                                            {{ result.breadcrumb !== result.title ? result.breadcrumb : '' }}
                                        </span>

                                    </a>
                                </li>
                            </ul>
                        </template>

                        <!-- Record results -->
                        <template v-if="recordResults.length > 0">
                            <div class="px-4 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider bg-gray-50 border-t border-gray-200">
                                Resultaten
                            </div>
                            <ul class="text-sm font-medium divide-y divide-gray-100">
                                <li v-for="(result, index) in recordResults" :key="'rec-' + index">
                                    <a :href="result.url"
                                       class="flex items-center justify-between px-4 py-3 transition-all duration-75"
                                       @mouseover="selectedResultIndex = result._globalIndex"
                                       :class="[result._globalIndex === selectedResultIndex ? 'bg-indigo-500 text-white' : 'text-gray-800 hover:bg-gray-50']">

                                        <span class="truncate">{{ result.title }}</span>

                                        <span class="text-xs ml-4 flex-shrink-0 px-2 py-0.5 rounded-full"
                                              :class="result._globalIndex === selectedResultIndex ? 'bg-indigo-400 text-white' : 'bg-gray-100 text-gray-500'">
                                            {{ result.model || (result.type === 'setting' ? 'Instelling' : 'Record') }}
                                        </span>

                                    </a>
                                </li>
                            </ul>
                        </template>

                        <!-- Searching indicator -->
                        <div v-if="isSearching && navigationResults.length === 0" class="border-t border-gray-200">
                            <div class="flex items-center justify-center gap-2 p-4 text-sm text-gray-500">
                                <svg class="animate-spin h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                                </svg>
                                <span>Zoeken...</span>
                            </div>
                        </div>

                        <!-- No results -->
                        <div v-if="noResults" class="border-t border-gray-200">
                            <span class="flex justify-center p-4 text-sm text-gray-500">Geen resultaten gevonden</span>
                        </div>

                    </div>

                    <!-- Keyboard hints -->
                    <div v-if="allResults.length > 0" class="flex items-center gap-4 px-4 py-2 text-xs text-gray-400 border-t border-gray-200 bg-gray-50">
                        <span><kbd class="px-1.5 py-0.5 rounded bg-gray-200 text-gray-500 font-mono">↑↓</kbd> navigeer</span>
                        <span><kbd class="px-1.5 py-0.5 rounded bg-gray-200 text-gray-500 font-mono">↵</kbd> openen</span>
                        <span><kbd class="px-1.5 py-0.5 rounded bg-gray-200 text-gray-500 font-mono">esc</kbd> sluiten</span>
                    </div>

                </div>
                </Transition>

            </div>

        </div>
        </Transition>

    </div>

</template>

<script>
import { defineComponent, ref, onMounted, watch, nextTick, computed } from '@vue/composition-api';
import axios from "@galaxy/modules/Core/resources/js/axiosBuilder";
import hotkeys from 'hotkeys-js';

export default defineComponent({
    name: 'Search',

    setup() {
        const showModal = ref(false);
        const searchTerm = ref('');
        const navigationIndex = ref([]);
        const navigationResults = ref([]);
        const recordResults = ref([]);
        const selectedResultIndex = ref(0);
        const searchTermInput = ref(null);
        const resultsContainer = ref(null);
        const searching = ref(false);
        const pendingSearch = ref(false);
        let debounceTimer = null;

        const allResults = computed(() => {
            const nav = navigationResults.value.map((r, i) => ({ ...r, _globalIndex: i }));
            const rec = recordResults.value.map((r, i) => ({ ...r, _globalIndex: nav.length + i }));

            // Write back _globalIndex for template access
            navigationResults.value.forEach((r, i) => r._globalIndex = i);
            recordResults.value.forEach((r, i) => r._globalIndex = nav.length + i);

            return [...nav, ...rec];
        });

        const isSearching = computed(() => {
            return searching.value || pendingSearch.value;
        });

        const noResults = computed(() => {
            return searchTerm.value.length >= 2 && !isSearching.value &&
                navigationResults.value.length === 0 && recordResults.value.length === 0;
        });

        const getPrefix = () => {
            let dataPrefix = $('html').data('prefix');
            return '/' + (dataPrefix !== undefined ? dataPrefix : 'admin/');
        };

        const loadNavigationIndex = async () => {
            if (navigationIndex.value.length > 0) return;

            try {
                const response = await axios.get(getPrefix() + 'search/navigation');
                navigationIndex.value = response.data;
            } catch {
                navigationIndex.value = [];
            }
        };

        const fuzzyMatch = (text, term) => {
            if (!text) return false;
            const lower = text.toLowerCase();
            const termLower = term.toLowerCase();

            // Direct substring match
            if (lower.includes(termLower)) return true;

            // Word-start matching: each search word must match start of some word
            const searchWords = termLower.split(/\s+/).filter(Boolean);
            const textWords = lower.split(/[\s>/\-_]+/).filter(Boolean);
            return searchWords.every(sw =>
                textWords.some(tw => tw.startsWith(sw))
            );
        };

        const filterNavigation = (term) => {
            if (term.length < 1) {
                navigationResults.value = [];
                return;
            }

            navigationResults.value = navigationIndex.value
                .filter(item => {
                    return fuzzyMatch(item.title, term) ||
                        fuzzyMatch(item.breadcrumb, term) ||
                        fuzzyMatch(item.keywords, term);
                })
                .slice(0, 5);
        };

        const searchRecords = async (term) => {
            if (term.length < 2) {
                recordResults.value = [];
                return;
            }

            searching.value = true;

            try {
                const response = await axios.get(getPrefix() + 'search/records', {
                    params: { term }
                });
                recordResults.value = response.data;
            } catch {
                recordResults.value = [];
            } finally {
                searching.value = false;
            }
        };

        const openModal = () => {
            showModal.value = true;
            loadNavigationIndex();
            nextTick(() => searchTermInput.value.focus());
        };

        const closeModal = () => {
            showModal.value = false;
            searchTerm.value = '';
            navigationResults.value = [];
            recordResults.value = [];
            selectedResultIndex.value = 0;
        };

        const closeModalIfNotInput = (event) => {
            if ($(event.target).is('input')) return;
            closeModal();
        };

        const scrollToSelected = () => {
            nextTick(() => {
                if (!resultsContainer.value) return;
                const selected = resultsContainer.value.querySelector('.bg-indigo-500');
                if (selected) selected.scrollIntoView({ block: 'nearest' });
            });
        };

        const selectPrevResult = () => {
            selectedResultIndex.value = Math.max(0, selectedResultIndex.value - 1);
            scrollToSelected();
        };

        const selectNextResult = () => {
            const total = allResults.value.length;
            selectedResultIndex.value = Math.min(total - 1, selectedResultIndex.value + 1);
            scrollToSelected();
        };

        const goToCurrentResultIndex = () => {
            const result = allResults.value.find(r => r._globalIndex === selectedResultIndex.value);
            if (result) {
                window.location.href = result.url;
            }
        };

        onMounted(() => {
            hotkeys.filter = function(event){
                return true;
            }

            hotkeys('ctrl+k, command+k', () => {
                if (!showModal.value) {
                    openModal();
                } else {
                    closeModal();
                }
            });
        });

        watch(searchTerm, (newVal) => {
            selectedResultIndex.value = 0;
            clearTimeout(debounceTimer);

            if (newVal.length >= 2) {
                // Set pending BEFORE filtering so noResults never flashes
                pendingSearch.value = true;
                recordResults.value = [];

                // Navigation filtering is instant (client-side)
                filterNavigation(newVal);

                // Records search is debounced (server-side)
                debounceTimer = setTimeout(() => {
                    pendingSearch.value = false;
                    searchRecords(newVal);
                }, 250);
            } else {
                pendingSearch.value = false;
                recordResults.value = [];
                filterNavigation(newVal);
            }
        });

        return {
            showModal,
            searchTerm,
            navigationResults,
            recordResults,
            allResults,
            selectedResultIndex,
            searchTermInput,
            resultsContainer,
            searching,
            isSearching,
            noResults,
            openModal,
            closeModal,
            closeModalIfNotInput,
            selectPrevResult,
            selectNextResult,
            goToCurrentResultIndex,
        };
    }
});

</script>
